import React from 'react';
import WorkOrders from './WorkOrders';

const InfrastructureManager: React.FC = () => {
  return <WorkOrders />;
};

export default InfrastructureManager;
